import { combineReducers } from 'redux';
import { truckManagementReducer } from '../../../features/truckmanagement/redux/reducer/truckManagementReducer';
import { autoPlannerReducer } from '../../../features/autoplanner/redux/reducer/autoPlannerReducer';
import { deliveryTrackingReducer } from '../../../features/deliverytracking/redux/reducer/deliveryTrackingReducer';
import { yaantracReducer } from '../../../features/yaantrac/redux/reducer/yaantracReducer';
import { commonReducer } from '../../../common/redux/reducer/commonReducer';

const appReducer = combineReducers({
  ...commonReducer,
  ...truckManagementReducer,
  ...autoPlannerReducer,
  ...deliveryTrackingReducer,
  ...yaantracReducer
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET') {
    state = {};
  }
  return appReducer(state, action);
};

export default rootReducer;
